module.exports = __webpack_public_path__ + "img/ejymjpg.d274e090.png";